import * as React from 'react'
import { Typography, Icons } from '@lacedltd/laced-components'
import * as S from './CartItem.styles'

const CartItem = ({ numberOfCartItems }: CartItemProps) => {
  return (
    <S.Container data-testid="cart-number-badge">
      <Icons.Cart />
      {!!numberOfCartItems && (
        <S.Bubble>
          <Typography.Text variant="caption">
            {numberOfCartItems > 9 ? `9+` : numberOfCartItems}
          </Typography.Text>
        </S.Bubble>
      )}
    </S.Container>
  )
}

interface CartItemProps {
  numberOfCartItems?: number
}

export default CartItem
